import React from 'react';
import { icons } from '../tools/icons';
import { jss } from '../tools/jss';
import { mui } from '../tools/mui';
import { Theme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

interface AvatarProps {
  avatarUrl: string;
  alt: string;
  to: string;
}

const useStyles = jss.makeStyles((theme: Theme) => ({
  avatar: {
    display: 'flex',
    height: 40,
    width: 40,
    alignItems: 'center',
    // Use "grey" instead of "gray" for consistent Material-UI naming
    backgroundColor: theme.palette.grey[500],
    color: 'rgba(0, 0, 0, 0.54)',
  },
  avatarLink: {
    display: 'block',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '1px solid #ddd',
  },
}));

const Avatar: React.FC<AvatarProps> = ({ avatarUrl, alt, to }) => {
  const styles = useStyles();

  return (
    <Link to={to} className={styles.avatarLink} data-testid="header-account">
      <mui.Avatar src={avatarUrl} alt={alt} className={styles.avatar}>
        <icons.Person />
      </mui.Avatar>
    </Link>
  );
};

export default Avatar;
